import { useInternalState, assignMswData, serializeQuery } from '../hooks/internalState';
import {
  PostVideoPrivateCommentReplyReactionsResult,
  PostVideoPrivateCommentReplyReactionsOptions,
  PostVideoPrivateCommentReplyReactionsFields,
  postVideoPrivateCommentReplyReactions,
} from '../fetchers/video/private_comment/reply/reactions';
import { useCallback } from 'react';
import { useSWRConfig } from 'swr';
import { useGctlConfig } from '../hooks/GctlProvider';

/**
 * DO NOT MODIFY
 * Auto-generated by gctl-plugin-vimeo-hooks
 */

type UsePostVideoPrivateCommentReplyReactionsOptions<
  Fields extends PostVideoPrivateCommentReplyReactionsFields,
> = PostVideoPrivateCommentReplyReactionsOptions<Fields>;

/**
 * Create a clip comment reaction
 * This method creates a clip comment reaction.
 */

export function usePostVideoPrivateCommentReplyReactions<
  Fields extends PostVideoPrivateCommentReplyReactionsFields,
>() {
  const { mutate } = useSWRConfig();
  let { baseUrl, jwt, xVimeoPage, locale } = useGctlConfig();

  let [state, dispatch] = useInternalState<
    PostVideoPrivateCommentReplyReactionsResult<Fields> | undefined
  >();

  let call = useCallback(
    async (options: UsePostVideoPrivateCommentReplyReactionsOptions<Fields>) => {
      dispatch({ type: 'REQUEST' });

      try {
        let result = await mutate(
          `/videos/${options.where.videoId}/private_comments/${options.where.commentId}/replies/${
            options.where.replyId
          }/reactions${serializeQuery(options)}`,
          postVideoPrivateCommentReplyReactions({
            ...options,
            baseUrl,
            headers: {
              ...options.headers,
              'Content-Type': 'application/json',
              Authorization: jwt ? `jwt ${jwt}` : '',
              'Vimeo-Page': `${xVimeoPage}`,
              'Accept-Language': locale ?? 'en',
            },
          }),
          false,
        );

        dispatch({ type: 'SUCCESS', payload: result });
      } catch (err) {
        dispatch({ type: 'FAILURE', payload: err });
      }
    },
    [baseUrl, xVimeoPage, jwt, locale, dispatch],
  );

  return [call, state] as const;
}

if (process.env.NODE_ENV !== 'production' || process.env.STORYBOOK === 'true') {
  assignMswData(usePostVideoPrivateCommentReplyReactions, {
    endpoint: '/videos/:videoId/private_comments/:commentId/replies/:replyId/reactions',
    method: 'POST',
  });
}
